import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConnectionsService } from '@vendasta/business-center';
import {
  GetFacebookAppCheckerResponseInterface,
  GetTwitterAppCheckerResponseInterface,
} from '@vendasta/business-center/lib/_internal';

@Injectable()
export class RepcoreApiService {
  private connectionsService = inject(ConnectionsService);

  getTwitterCustomAppConnections(accountGroupId: string): Observable<GetTwitterAppCheckerResponseInterface> {
    return this.connectionsService.getTwitterAppChecker(accountGroupId).pipe(
      map((res) => res),
      catchError(() => of<GetTwitterAppCheckerResponseInterface>({ reconnectGroup: [], totalConnections: 0 })),
    );
  }

  getFacebookAppConnections(accountGroupId: string): Observable<GetFacebookAppCheckerResponseInterface> {
    return this.connectionsService.getFacebookAppChecker(accountGroupId).pipe(
      map((res) => res),
      catchError(() =>
        of<GetFacebookAppCheckerResponseInterface>({
          reconnectNeeded: false,
          reconnectGroup: [],
          totalConnections: 0,
        }),
      ),
    );
  }
}
